import { emailValidation } from "../../utils/GeneralUtils";

const validate = (values: any) => {
  const errors: {
    businessName: any;
    businessZipCode: any;
    businessPhoneNumber: any;
    phoneNumber: any;
    phoneType: any;
    email: any;
    emailType: any;
    businessEmailType: any;
    businessPhoneType: any;
    businessEmail: any;
    title: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    contactFirstName: string|undefined;
    newEmail?: string|undefined;
  } = {
    phoneNumber: undefined,
    phoneType: undefined,
    email: undefined,
    emailType: undefined,
    businessName: undefined,
    businessEmail: undefined,
    businessEmailType: undefined,
    businessPhoneNumber: undefined,
    businessPhoneType: undefined,
    title: undefined,
    firstName: undefined,
    lastName: undefined,
    businessZipCode: undefined,
    contactFirstName:undefined,
    newEmail: undefined,
  };

  if (!values.businessName) {
    errors.businessName = "Required";
  } 
  if(!values.rolodexFirstName){
    errors.contactFirstName = 'Required';
  }

  if (
    values.businessEmail &&
    !emailValidation().test(values.businessEmail)
  ) {
    errors.businessEmail = "*Please enter your email in format: yourname@example.com";
  }
  if (values.businessPhoneNumber) {
    if (values.businessPhoneNumber.length < 11) {
      errors.businessPhoneNumber = "Enter 10 digits";
    }
  }

  if (
    values.businessZipCode === "0" ||
    values.businessZipCode === "00" ||
    values.businessZipCode === "000" ||
    values.businessZipCode === "0000" ||
    values.businessZipCode === "00000"
  ) {
    errors.businessZipCode = "Invalid zip";
  }
  if (
    values?.businessZipCode?.length < 5 &&
    values?.businessZipCode?.length !== 0
  ) {
    errors.businessZipCode = "Atleast 5 digits required";
  }

  
  if (values.businessEmail && !values.businessEmailType) {
    errors.businessEmailType = "Required";
  }
  if (values.businessEmailType && !values.businessEmail) {
    errors.businessEmail = "Required";
  }
  if (values.businessPhoneNumber) {
    if (values.businessPhoneNumber.length < 11) {
      errors.businessPhoneNumber = "Enter 10 digits";
    }
      if (values.businessPhoneNumber.length){ 
      if(!values.businessPhoneType)
      {
        errors.businessPhoneType = "Required";
      }

      }
    
    }
  
    
  
  if (values.businessPhoneType && !values.businessPhoneNumber) {
    errors.businessPhoneNumber = "Required";
  }
  if (values.email && !values.emailType) {
    errors.emailType = "Required";
  }
  if (values.emailType && !values.email) {
    errors.email = "Required";
  }
  if (values.phoneNumber && !values.phoneType) {
    errors.phoneType = "Required";
  }
  if (values.phoneType && !values.phoneNumber) {
    errors.phoneNumber = "Required";
  }
  if (
    values.newEmail &&
    !emailValidation().test(values.newEmail)
  )
  {
    errors.newEmail = "*Please enter your email in format: yourname@example.com";
  }
  

  return errors;
};

export default validate;
